import { render, staticRenderFns } from "./infiniteList.vue?vue&type=template&id=52f13c60&scoped=true&"
import script from "./infiniteList.vue?vue&type=script&lang=js&"
export * from "./infiniteList.vue?vue&type=script&lang=js&"
import style0 from "./infiniteList.vue?vue&type=style&index=0&id=52f13c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f13c60",
  null
  
)

export default component.exports